import { Injectable, NgZone } from '@angular/core';
import { Settings } from '../settings';
import { NavController, Platform, ToastController, AlertController } from 'ionic-angular';
import { LoadingProvider } from './loading';
import { AlertProvider } from './alert';
import { DataProvider } from './data';
import { UserProvider } from './user';
import { TeamappProvider } from './teamapp';
import { MessageProvider } from './message';
import { Http,Headers,RequestOptions } from '@angular/http';

import { RegisterPage } from '../pages/register/register';


@Injectable()
export class LoginProvider {

  private navCtrl: NavController;
  constructor(public loadingProvider: LoadingProvider,public userProvider: UserProvider,public messageProvider: MessageProvider, public dataProvider: DataProvider, public alertProvider: AlertProvider, public zone: NgZone,
              public alertCtrl: AlertController, public platform: Platform, public http: Http, public toastCtrl: ToastController, public alert: AlertController, public teamappProvider: TeamappProvider) {
        //this.checkLogin();
  }

  setNavController(navCtrl) {
    this.navCtrl = navCtrl;
  }

  // Login on Firebase given the email and password.
  emailLogin(email, password) {
    this.loadingProvider.show();

    //console.log(Settings.teamAppApiUrl +'/structure/login.php?api_token='+Settings.teamAppApiToken+'&user_name='+email+'&user_password='+password+'&user_device_unique_id='+this.device.uuid);
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    let options = new RequestOptions({ headers: headers });

    this.http.post(Settings.teamAppApiUrl +'/structure/login.php', 'api_token='+Settings.teamAppApiToken+'&user_name='+encodeURI(email)+'&user_password='+encodeURI(password)+'&user_device_unique_id=null&standalone='+Settings.standalone, options).subscribe((response) => {
        console.log(response);
        let responseApi = response.json();
        if(!responseApi.code && responseApi.user_status == 3) {
            if(Settings.standalone == true) {
                localStorage.setItem('api_key',responseApi.api_key);
                this.userProvider.setUserCompanyColorA(responseApi.company_color_a);
                this.userProvider.setUserCompanyColorB(responseApi.company_color_b);
                this.userProvider.setUserCompanyLogo(responseApi.company_logo);
                this.userProvider.setUserAppVersion(Settings.appVersion);
                this.userProvider.setUserStatus(responseApi.status);
                this.teamappProvider.check_api_token();
            }
            localStorage.setItem('app_user',responseApi.user_secret_token);
            this.userProvider.setUserID(responseApi.user_key);
            this.userProvider.setUserType(responseApi.user_type);
            if(responseApi.require_firebase_register == 0) {
                this.loadingProvider.hide();

                this.userProvider.setUserName(responseApi.user_name, responseApi.user_surname);
                this.userProvider.setUserImage(responseApi.user_image);
                this.userProvider.setUserPersonalNumber(responseApi.user_personal_number);
                this.userProvider.setUserAppVersion(Settings.appVersion);
                this.navCtrl.setRoot(Settings.afterLoginPage, { animate: false });
                this.userProvider.setUserLogin(true);

                //this.login();
            } else if(responseApi.require_firebase_register == 1) {
                this.register(responseApi.user_name, responseApi.user_surname, responseApi.user_name+responseApi.user_surname, responseApi.firebase_email, responseApi.firebase_password,"./assets/images/default-dp.png",responseApi.user_secret_token, responseApi.user_personal_number);
            }

        } else {
            this.loadingProvider.hide();
            localStorage.removeItem('app_user');
            this.alertProvider.showErrorMessage('auth/invalid-credential');
        }
    });
  }

  login() {

      this.messageProvider.startListen();
      /*let user_data = user_db.payload.val();

      this.userProvider.setUserName(user_data.name, user_data.surname);
      this.userProvider.setUserImage(user_data.img);
      this.userProvider.setUserPersonalNumber(user_data.user_personal_number);

      console.log(user_data);
      console.log("IMPORT FROM FIREBASE ");*/

      this.navCtrl.setRoot(Settings.afterLoginPage, { animate: false });
      this.userProvider.setUserLogin(true);
  }

  // Register user on Firebase given the email and password.
  register(name, surname,  username, email, password, img, teamapp_secret, teamapp_personal_id) {
    this.loadingProvider.show();

    this.createNewUser(teamapp_secret, name ,surname, username,email.toLowerCase(),"Verfügbar","Firebase",img, 'none', teamapp_secret, teamapp_personal_id);
    this.loadingProvider.hide();

    this.platform.is('android') ? this.initializeFirebaseAndroid() : this.initializeFirebaseIOS();
  }


  enableSettings() {
      //Registering for push notification
      (<any>window).FirebasePlugin.hasPermission(data => {
          if (data != true) {
              (<any>window).FirebasePlugin.grantPermission(hasPermission => {
                  if(hasPermission == 'granted') {
                      (<any>window).FirebasePlugin.getToken(token => {
                          localStorage.setItem('isPushEnabled', 'true');
                      }).catch(err => {
                          console.log(err);
                      });
                      (<any>window).FirebasePlugin.onTokenRefresh(token => {
                      });
                  }
              });
          }
          else {
              (<any>window).FirebasePlugin.getToken(token => {
                  console.log(token);
                  localStorage.setItem('isPushEnabled', 'true');
              }).catch(err => {
                  console.log(err);
              });
              (<any>window).FirebasePlugin.onTokenRefresh(token => {
                  console.log(token);
              });
          }
      });
  }

    initializeFirebaseAndroid() {
      if(this.platform.is('cordova')) {
        this.enableSettings();
      }
  }

  initializeFirebaseIOS() {
    if(this.platform.is('cordova')) {
        this.enableSettings();
    }
  }

  // Creating new user after signed up
  createNewUser(userId,name,surname,username,email,description = "Verfügbar",provider,img="./assets/images/default-dp.png", gender='none', teamapp_secret,user_personal_number){

    let publicVisibility: boolean = false;
    if(this.userProvider.getUserType() == 'employee') {
        publicVisibility = true;
    } else {
        publicVisibility = false;
    }

    let online: boolean = true;
    this.http.get(Settings.teamAppApiUrl +'/structure/firebase.php?api_token='+Settings.teamAppApiToken+'&user_secret='+teamapp_secret+'&user_firebase_id='+userId+'&action=update_firebase_token').subscribe((response) => {
        let dateCreated = new Date();
    });

    this.userProvider.setUserFirebaseID(userId);
    this.userProvider.setUserID(userId);
    this.userProvider.setUserName(name, surname);
    this.userProvider.setUserImage(img);
    this.userProvider.setUserPersonalNumber(user_personal_number);

    this.navCtrl.setRoot(Settings.afterLoginPage);
    this.userProvider.setUserLogin(true);
  }

  checkLogin() {
      this.loadingProvider.show();
      let userKey: string = localStorage.getItem("app_user");
      if (userKey) {
          this.http.get(Settings.teamAppApiUrl + '/structure/check.php?api_token=' + Settings.teamAppApiToken + '&user_device_unique_id=null&user_secret=' + userKey +'&standalone='+Settings.standalone).subscribe((response) => {

              console.log("== DEBUG / CHECK LOGIN");
              console.log(Settings.teamAppApiUrl + '/structure/check.php?api_token=' + Settings.teamAppApiToken + '&user_device_unique_id=null&user_secret=' + userKey +'&standalone='+Settings.standalone);

              let ret = response.json();

              console.log(ret);
              if (ret.success == 1) {

                  if(Settings.standalone == true) {
                      localStorage.setItem('api_key',ret.api_key);
                      this.userProvider.setUserCompanyColorA(ret.company_color_a);
                      this.userProvider.setUserCompanyColorB(ret.company_color_b);
                      this.userProvider.setUserCompanyLogo(ret.company_logo);
                      this.teamappProvider.check_api_token();
                  }

                  this.userProvider.setUserID(ret.key);
                  this.userProvider.setUserType(ret.type);
                  this.userProvider.setUserLogin(true);
                  this.userProvider.setUserAppVersion(Settings.appVersion);
                  this.userProvider.setUserStatus(ret.status);

                  this.navCtrl.setRoot(Settings.afterLoginPage, {animate: false});
                  this.loadingProvider.hide();


                  this.messageProvider.startListen();
                  this.messageProvider.getConversions();

                  //let user_data = user_db.payload.val();

                  this.userProvider.setUserFirebaseID(ret.user.firebase_token);
                  //this.userProvider.setUserFirebaseData(user_data);
                  this.userProvider.setUserName(ret.user.firstname, ret.user.name);
                  this.userProvider.setUserImage(ret.user.userimg);
                  this.userProvider.setUserPersonalNumber(ret.user.personal_id);



              } else {
                  this.loadingProvider.hide();

                  if (ret.reason == 7) { //INVALID PHONE SERIAL ID
                      this.alertProvider.showErrorMessage('auth/invalid-phoneserial');
                      localStorage.removeItem("app_user");

                  } else {
                      this.alertProvider.showErrorMessage('auth/invalid-credential');
                      localStorage.removeItem("app_user");
                  }

              }

          });
      } else {
          this.loadingProvider.hide();
          this.navCtrl.setRoot(Settings.guestHomePage);
      }
  }

  checkQrCode(code: string) {
    this.http.get(Settings.teamAppApiUrl +'/structure/qrcode.php?api_token='+Settings.teamAppApiToken+'&qr_code='+code+'&user_device_unique_id=null').subscribe((response) => {
      let data = response.json();
      if(data && data.valid == 1) {
          this.navCtrl.setRoot(RegisterPage, { qr: code });
      } else if(data && data.valid == 2) {
          this.alertProvider.showErrorMessage('auth/code-updated');
          this.navCtrl.pop();
      } else {
          this.alertProvider.showErrorMessage('auth/invalid-credential');
          this.navCtrl.pop();
      }

    });
  }

  checkPinCode(code: string) {
      this.http.get(Settings.teamAppApiUrl +'/structure/qrcode.php?api_token='+Settings.teamAppApiToken+'&pin_code='+code+'&user_device_unique_id=null').subscribe((response) => {
          let data = response.json();
          if(data && data.valid == 1) {
              console.log("QR Code => "+data.qrcode);
              this.navCtrl.setRoot(RegisterPage, { qr: data.qrcode });
          } else {
              this.alertProvider.showErrorMessage('auth/invalid-credential');
              this.navCtrl.pop();
          }

      });
  }

  forgetPasswort() {
      let alert = this.alertCtrl.create({
          title: 'Passwort zurücksetzen',
          inputs: [
              {
                  name: 'email',
                  placeholder: 'E-Mail'
              },
          ],
          buttons: [
              {
                  text: 'Abbrechen',
                  role: 'cancel',
                  handler: data => {
                      console.log('Cancel clicked');
                  }
              },
              {
                  text: 'Passwort zurücksetzen',
                  handler: data => {
                    if(data.email.length > 5) {
                        this.http.get(Settings.teamAppApiUrl +'/structure/reset.php?api_token='+Settings.teamAppApiToken+'&email='+data.email+'&user_device_unique_id=null').subscribe((response) => {
                            let data = response.json();
                            if(data && data.user_valid == 1) {
                                console.log("valid user to reset");
                                let alert = this.alertCtrl.create({
                                    title: 'Passwort zurücksetzen',
                                    subTitle: 'Bitte die E-Mails überprüfen',
                                    buttons: ['OK']
                                });
                                alert.present();
                            } else {
                                let alert = this.alertCtrl.create({
                                    title: 'Fehler',
                                    subTitle: 'Es wurde kein Account mit dieser E-Mail gefunden',
                                    buttons: ['OK']
                                });
                                alert.present();
                            }

                        });
                    } else {
                        return false;
                    }
                  }
              }
          ]
      });
      alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/login.ts